import {post} from "./request";

export const normalizeEstimateResponse = (response) => {
  const payload = response?.data || response || {};
  const estimation = payload.estimation || {};
  const min = Number(estimation.estimated_min ?? estimation.min);
  const max = Number(estimation.estimated_max ?? estimation.max);

  if (!Number.isFinite(min) || !Number.isFinite(max) || min <= 0 || max < min) {
    throw new Error("Réponse d'estimation invalide");
  }

  return {
    min,
    max,
    service: payload.extracted?.service || "",
    confidence: estimation.confidence || "low",
    explanation: estimation.explanation || "",
    source: payload.meta?.source || "",
    historicalCount: Number(payload.meta?.historical_count) || 0,
    localHistoricalSample: Boolean(payload.meta?.local_historical_sample),
    webUsed: Boolean(payload.meta?.web_used),
  };
};

export const getOfferPriceEstimate = async ({
  title,
  description,
  postCode,
  subCategoryIds,
  signal,
}) => {
  const response = await post(
    "/ai-estimation",
    {
      title,
      description,
      postal_code: postCode || null,
      sub_category_ids: subCategoryIds,
    },
    {},
    {signal},
  );
  return normalizeEstimateResponse(response);
};
